import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { dataDefault } from 'Components/User/BagRequests/BagRequests'
import { apiCollectionPointBagRequestsList, apiCollectionPointBagRequestsView } from 'Services/UserService'

export const getData = createAsyncThunk('user/collectionPointBagRequests/getData', async datas => {
    const { data } = await apiCollectionPointBagRequestsList(datas)
    return data
})

export const getView = createAsyncThunk('user/collectionPointBagRequests/getView', async id => {
    if (!id) return viewData
    const { data } = await apiCollectionPointBagRequestsView(id)
    data.material_type = data.material_type && data.material_type.length !== 0 ? data.material_type : [dataDefault]
    return data
})

const viewData = {
    material_type: [dataDefault],
}

export const collectionPointBagRequestsSlice = createSlice({
    name: 'user/collectionPointBagRequests',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = collectionPointBagRequestsSlice.actions

export default collectionPointBagRequestsSlice.reducer
